import { Headers } from '@egw/components'
import { SavingsAccountPage as FeatureSavingsAccountPage } from '@egw/features-account'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'
import { useParams } from 'react-router'

export const SavingsAccountPage: FC = () => {
  const { t } = useTranslation()
  const { alias } = useParams<{ alias: string }>()

  return alias ? (
    <Layout>
      <Headers title={t('pages.savings.title')} />
      <FeatureSavingsAccountPage alias={parseInt(alias)} />
    </Layout>
  ) : null
}
